﻿import { SystemBase } from "./system.base";

export class FrameSystem extends SystemBase {

    update(time: number, delta: number): void {

    }

    endOfFrame(): void {
        
    }
}